import { PrimaryButton } from 'office-ui-fabric-react';
import React from 'react';

const numberStyle = {
  backgroundColor: '#0078d4',
  color: 'white',
};
const CommentSectionHeader = ({
  headerText,
  numberOfComments,
  onCreateCommentClick,
  createCommentText,
  disableCreateCommentButton,
}) => {
  return (
    <div>
      <hr className="create-hearing-header-hr" />
      <div className="create-comment-header">
        <div>
          <h2>{headerText}</h2>
          <span className="number" style={numberStyle}>
            {numberOfComments}
          </span>
        </div>
        {!disableCreateCommentButton && (
          <div>
            <PrimaryButton
              text={createCommentText}
              onClick={onCreateCommentClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { CommentSectionHeader };
